__turbopack_context__.v({
  "as-featured": "styles-module-scss-module__torl7a__as-featured",
  "as-featured__brands": "styles-module-scss-module__torl7a__as-featured__brands",
  "as-featured__brands_item": "styles-module-scss-module__torl7a__as-featured__brands_item",
  "as-featured__brands_item_wsj-icon": "styles-module-scss-module__torl7a__as-featured__brands_item_wsj-icon",
  "as-featured__title": "styles-module-scss-module__torl7a__as-featured__title",
  "default-container": "styles-module-scss-module__torl7a__default-container",
  "section-asFeatured": "styles-module-scss-module__torl7a__section-asFeatured",
  "section-asFeatured__it-shows--hide": "styles-module-scss-module__torl7a__section-asFeatured__it-shows--hide",
});
